/**
 * Enum representing the type of wallet the user is stamping with.
 */
var WalletType;
(function (WalletType) {
    WalletType["Ethereum"] = "ethereum";
    WalletType["Solana"] = "solana";
})(WalletType || (WalletType = {}));

export { WalletType };
//# sourceMappingURL=types.mjs.map
